<template>
</template>
<script type="text/javascript">
const variant_information =[
  // { label: 'Chr',value:1},
  { label: 'Func.refGene',value:6},
  // { label: '',value:false},
  // { label: 'Start',value:2},
  // { label: 'Gene.refGene',value:7},
  // { label: 'End',value:3},
  { label: 'GeneDetail.refGene',value:8},
  // { label: '',value:false},
  // { label: 'Ref',value:4},
  { label: 'ExonicFunc.refGene',value:9},
  // { label: 'Alt',value:5},
  { label: 'omim',value:11},
  { label: 'AAChange.refGene',value:10},
  // { label: 'chr.loc',value:115},

  // { label: 'cDNA',value:116},
  // { label: 'AA',value:117},
  // { label: 'NM',value:118},
  // { label: 'rank',value:119},
  // { label: 'geno',value:120},
  { label: 'avsnp150',value:12}
]

const population =[
  { label: 'inhouse',value:122,pWidth:'28%'},
  { label: 'Max_Population',value:41,pWidth:'36%'},
  { label: '1000g2015aug_all',value:39,pWidth:'36%'},

  { label: '',value:false,pWidth:'22.5%'},
  { label: 'Max_Allele_Frequency',value:38,pWidth:'36%'},
  { label: '1000g2015aug_afr',value:40,pWidth:'30%'},

  { label: 'ExAC_ALL',value:13,pWidth:'28%'},
  { label: 'gnomAD_exome_ALL',value:14,pWidth:'36%'},
  { label: 'gnomAD_genome_ALL',value:15,pWidth:'36%'},

  { label: 'ExAC_AFR',value:16,pWidth:'28%'},
  { label: 'gnomAD_exome_AFR',value:17,pWidth:'36%'},
  { label: 'gnomAD_genome_AFR',value:18,pWidth:'36%'},

  { label: 'ExAC_AMR',value:19,pWidth:'28%'},
  { label: 'gnomAD_exome_AMR',value:20,pWidth:'36%'},
  { label: 'gnomAD_genome_AMR',value:21,pWidth:'36%'},

  { label: '',value:false,pWidth:'28%'},
  { label: 'gnomAD_exome_ASJ',value:22,pWidth:'36%'},
  { label: 'gnomAD_genome_ASJ',value:23,pWidth:'36%'},

  { label: 'ExAC_EAS',value:24,pWidth:'28%'},
  { label: 'gnomAD_exome_EAS',value:25,pWidth:'36%'},
  { label: 'gnomAD_genome_EAS',value:26,pWidth:'36%'},

  { label: 'ExAC_FIN',value:27,pWidth:'28%'},
  { label: 'gnomAD_exome_FIN',value:28,pWidth:'36%'},
  { label: 'gnomAD_genome_FIN',value:29,pWidth:'36%'},

  { label: 'ExAC_NFE',value:30,pWidth:'28%'},
  { label: 'gnomAD_exome_NFE',value:31,pWidth:'36%'},
  { label: 'gnomAD_genome_NFE',value:32,pWidth:'36%'},

  { label: 'ExAC_OTH',value:33,pWidth:'28%'},
  { label: 'gnomAD_exome_OTH',value:34,pWidth:'36%'},
  { label: 'gnomAD_genome_OTH',value:35,pWidth:'36%'},

  { label: 'ExAC_SAS',value:36,pWidth:'28%'},
  { label: 'gnomAD_exome_SAS',value:37,pWidth:'36%'},


]
const disease =[
  { label: 'CLINSIG',value:42},
  { label: 'CLNDSDB',value:45},
  { label: 'CLNDBN',value:43},
  { label: 'CLNDSDBID',value:46},
  { label: 'CLNACC',value:44},
  { label: 'hgmd-pro',value:47}
]
const acmg =[
  { label: 'ACMG',value:123,pWidth:'36%'},
  { label: 'PM1',value:49,pWidth:'15%'},
  { label: 'PP1',value:50,pWidth:'15%'},
  { label: 'BA1',value:51,pWidth:'15%'},
  { label: 'BP1',value:52,pWidth:'15%'},

  { label: 'InterVar_automated',value:48,pWidth:'36%'},
  { label: 'PM2',value:54,pWidth:'15%'},
  { label: 'PP2',value:55,pWidth:'15%'},
  { label: 'BS1',value:56,pWidth:'15%'},
  { label: 'BP2',value:57,pWidth:'15%'},

  { label: 'PVS1',value:53,pWidth:'36%'},
  { label: 'PM3',value:59,pWidth:'15%'},
  { label: 'PP3',value:60,pWidth:'15%'},
  { label: 'BS2',value:61,pWidth:'15%'},
  { label: 'BP3',value:62,pWidth:'15%'},

  { label: 'PS1',value:58,pWidth:'36%'},
  { label: 'PM4',value:64,pWidth:'15%'},
  { label: 'PP4',value:65,pWidth:'15%'},
  { label: 'BS3',value:66,pWidth:'15%'},
  { label: 'BP4',value:67,pWidth:'15%'},

  { label: 'PS2',value:63,pWidth:'36%'},
  { label: 'PM5',value:69,pWidth:'15%'},
  { label: 'PP5',value:70,pWidth:'15%'},
  { label: 'BS4',value:71,pWidth:'15%'},
  { label: 'BP5',value:72,pWidth:'15%'},

  { label: 'PS3',value:68,pWidth:'36%'},
  { label: 'PM6',value:74,pWidth:'15%'},
  { label: '',value:false,pWidth:'15%'},
  { label: '',value:false,pWidth:'15%'},
  { label: 'BP6',value:75,pWidth:'15%'},

  { label: 'PS4',value:73,pWidth:'36%'},
  { label: '',value:false,pWidth:'15%'},
  { label: '',value:false,pWidth:'15%'},
  { label: '',value:false,pWidth:'15%'},
  { label: 'BP7',value:76,pWidth:'15%'},
]

const prediction =[
  { label: 'genomicSuperDups',value:82},
  { label: 'Interpro_domain',value:77},
  { label: 'dbscSNV_ADA_SCORE',value:78},
  { label: 'dbscSNV_RF_SCORE',value:79},
  { label: 'PP3/BP4',value:121},
  { label: 'REVEL',value:80},
  { label: 'MCAP',value:81},

]
const prediction_missense =[
  { label: 'deleterious_count',value:83},
  { label: 'others (63)',value:84}
]
const variant_information2 =[
  { label: 'Heterozygosity',value:85},
  { label: 'Mutation',value:86},
  { label: 'Depth',value:87},
  { label: 'Quality',value:88},
  { label: 'Chrom',value:89},
  { label: 'QC',value:90},
  { label: 'Position',value:91},
  { label: 'Depth_Column',value:92},
  { label: 'Wild_Type',value:93},
  { label: 'Depth_Detail',value:94}
]

const exomiser =[
  { label: 'FUNCTIONAL_CLASS',value:95},
  { label: 'HGVS',value:96},
  { label: 'EXOMISER_GENE',value:97},
  { label: 'CADD(>0.483)',value:98},
  { label: 'POLYPHEN(>0.956|>0.446)',value:99},
  { label: 'MUTATIONTASTER(>0.94)',value:100},
  { label: 'SIFT(<0.06)',value:101},
  { label: 'REMM',value:102},
  { label: 'MAX_FREQUENCY',value:103},
  { label: 'DBSNP_FREQUENCY',value:104},
  { label: 'EVS_EA_FREQUENCY',value:105},
  { label: 'EVS_AA_FREQUENCY',value:106},
  { label: 'EXOMISER_VARIANT_SCORE',value:107},
  { label: 'EXOMISER_GENE_PHENO_SCORE',value:108},
  { label: 'EXOMISER_GENE_VARIANT_SCORE',value:109},
  { label: 'EXOMISER_GENE_COMBINED_SCORE',value:110},
  { label: 'CONTRIBUTING_VARIANT',value:111},
]
const prediction_MitoDNA =[
  { label: 'regsnp_disease',value:124},
  { label: 'regsnp_splicing_site',value:125},
  { label: 'others (77)',value:126},
]
const group_prediction =[
  { label: 'group Prediction_Function(15)',value:112},
  // { label: 'group Prediction_MitoDNA (79)',value:113},
  { label: 'group Prediction_Others (3)',value:114},
]
var pwidth='14%'
const acmg_filter =[
  { label: 'PVS1',value:false,pWidth:pwidth},
  { label: 'PS1',value:false,pWidth:pwidth},
  { label: 'PS2',value:false,pWidth:pwidth},
  { label: 'PS3',value:false,pWidth:pwidth},
  { label: 'PS4',value:false,pWidth:pwidth},
  { label: 'PM1',value:false,pWidth:pwidth},
  { label: 'PM2',value:false,pWidth:pwidth},
  { label: 'PM3',value:false,pWidth:pwidth},
  { label: 'PM4',value:false,pWidth:pwidth},
  { label: 'PM5',value:false,pWidth:pwidth},
  { label: 'PM6',value:false,pWidth:pwidth},
  { label: 'PP1',value:false,pWidth:pwidth},
  { label: 'PP2',value:false,pWidth:pwidth},
  { label: 'PP3',value:false,pWidth:pwidth},
  { label: 'PP4',value:false,pWidth:pwidth},
  { label: 'PP5',value:false,pWidth:pwidth},
  { label: 'BA1',value:false,pWidth:pwidth},
  { label: 'BS1',value:false,pWidth:pwidth},
  { label: 'BS2',value:false,pWidth:pwidth},
  { label: 'BS3',value:false,pWidth:pwidth},
  { label: 'BS4',value:false,pWidth:pwidth},
  { label: 'BP1',value:false,pWidth:pwidth},
  { label: 'BP2',value:false,pWidth:pwidth},
  { label: 'BP3',value:false,pWidth:pwidth},
  { label: 'BP4',value:false,pWidth:pwidth},
  { label: 'BP5',value:false,pWidth:pwidth},
  { label: 'BP6',value:false,pWidth:pwidth},
  { label: 'BP7',value:false,pWidth:pwidth}
]

export default{
  variant_information,
  variant_information2,
  population,
  acmg,
  disease,
  prediction,
  prediction_missense,
  exomiser,
  group_prediction,
  prediction_MitoDNA,
  acmg_filter
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/const/Global.vue